export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14524.1ed4480e.jpg";